import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Box, Button, Dropdown, DropdownMenuItem, Typography} from 'views/components';
import {MarkdownEditor, Translate, translate} from 'views/module';

const StageDropdown = (props) => {
  const {selectedStage, setSelectedStage} = props;
  const [isReasonDialogOpen, setIsReasonDialogOpen] = React.useState(false);
  const [pendingStage, setPendingStage] = React.useState(null);
  const [statusReason, setStatusReason] = React.useState('');

  const statusRequiringReason = ['INACTIVE', 'CLOSED_LOST'];

  const stages = Object.entries(translate('client.Status'));
  const pendingStageTitle = pendingStage ? translate(`client.Status.${pendingStage}.Title`) : '';

  const closeReasonDialog = () => {
    setIsReasonDialogOpen(false);
    setPendingStage(null);
    setStatusReason('');
  };

  const handleOptionSelect = (selectedOption) => {
    if (!selectedOption || selectedOption === selectedStage) {
      return;
    }

    if (statusRequiringReason.includes(selectedOption)) {
      setPendingStage(selectedOption);
      setIsReasonDialogOpen(true);
      return;
    }

    setSelectedStage(selectedOption);
  };

  const handleSaveReason = () => {
    const trimmedReason = statusReason.trim();
    if (!pendingStage || !trimmedReason) {
      return;
    }

    setSelectedStage(pendingStage, {
      blob: trimmedReason,
      editorType: 'MARKDOWN',
    });
    closeReasonDialog();
  };

  return (
    <>
      <Box>
        <Dropdown
          onChange={handleOptionSelect}
          value={selectedStage}
          label={translate('client.ClientDetail.Status.Menu.Subtitles.Stage')}
        >
          {
            stages.map(([k, v]) => {
              return (
                <DropdownMenuItem key={k} value={k}>
                  {v.Title}
                </DropdownMenuItem>
              );
            })
          }
        </Dropdown>
      </Box>
      {
        isReasonDialogOpen &&
        <Dialog onClose={closeReasonDialog} open={isReasonDialogOpen}>
          <DialogTitle onClose={closeReasonDialog}>
            <Translate expression='client.ClientDetail.ChangeStatusDialog.ReasonTitle' />
          </DialogTitle>
          <DialogContent>
            <Box sx={{mt: 1, minWidth: {sm: '28rem'}}}>
              <Typography sx={{mb: 2}}>
                <Translate
                  expression='client.ClientDetail.ChangeStatusDialog.ReasonPrompt'
                  substitute={{status: pendingStageTitle}}
                />
              </Typography>
              <Typography variant="body2" sx={{mb: 1}}>
                {translate('client.ClientDetail.ChangeStatusDialog.Reason')}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{mb: 1}}>
                {translate('client.ClientDetail.ChangeStatusDialog.ReasonPlaceholder')}
              </Typography>
              <MarkdownEditor
                autoFocus
                height={220}
                value={statusReason}
                onChange={(value) => setStatusReason(value || '')}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' onClick={closeReasonDialog}>
              <Translate expression='generic.Cancel' />
            </Button>
            <Button color="primary" onClick={handleSaveReason} disabled={!statusReason.trim()}>
              <Translate expression='generic.Save' />
            </Button>
          </DialogActions>
        </Dialog>
      }
    </>
  );
};

StageDropdown.propTypes = {
  selectedStage: PropTypes.string,
  setSelectedStage: PropTypes.func.isRequired,
};

export default StageDropdown;
